import { BufferingSequencer } from '@augloop/buffering-sequencer';
var BufferingSequencerFactory = /** @class */ (function () {
    function BufferingSequencerFactory(bufferingTimeMs) {
        if (bufferingTimeMs === void 0) { bufferingTimeMs = 500; }
        this.bufferingTimeMs = 500;
        this.workflowIdToSequencersMap = new Map();
        this.bufferingTimeMs = bufferingTimeMs;
    }
    BufferingSequencerFactory.prototype.create = function (annotation) {
        if (!annotation.ownerId) {
            return null;
        }
        var sequencer = this.workflowIdToSequencersMap.get(annotation.ownerId);
        if (!sequencer) {
            sequencer = new BufferingSequencer(this.bufferingTimeMs);
            this.workflowIdToSequencersMap.set(annotation.ownerId, sequencer);
        }
        return sequencer;
    };
    return BufferingSequencerFactory;
}());
export { BufferingSequencerFactory };
//# sourceMappingURL=buffering-sequencer-factory.js.map